<template>
  <!-- Five logos + Footer -->
  <section id="footer">
    <!-- Insert "FooterLogo"  and "FooterMain"-->
    <slot />
  </section>
</template>

<script>
export default {
  name: "FooterSection",
};
</script>
